const en = {
  translation: {
    //Menu
    dashboard: "Dashboard",
    reports: "Reports",
    contact: "Contact",
    settings: "Settings",
    profile: "Profile",
    logout: "Logout",

    //Dashboard
    budget: "Budget",
    totalIncome: "Total Income",
    totalExpense: "Total Expense",

    income: "Income",
    expense: "Expense",

    expenseStructure: "Expense Structure",
    incomeStructure: "Income Structure",
    today: "Today",
    thisWeek: "This Week",
    thisMonth: "This Month",
    lastMonths: "Last {{monthCount}} Months",
    thisYear: "This Year",
    lastRecords: "Last {{lastRecordDayCount}} Records",
    description: "Description",
    actions: "Actions",

    // Reports
    all: "All",
    incomes: "Incomes",
    expenses: "Expenses",

    //Contact Us
    contactUs: "Contact Us",
    subject: "Subject",
    explanation: "Explanation",
    submit: "Submit",
    contactInfo:"Send us your requests, suggestions and complaints. Let's develop the app",

    // Settings
    currencyType: "Currency Type",
    update: "Update",

    //Form
    addTransaction: "Add Transaction",
    editTransaction: "Edit Transaction",

    amount: "Amount",
    category: "Category",
    date: "Date",
    type: "Type",
    save: "Save",
    close: "Close",

    typeStatus: "Type Status",
    request: "Discretionary",
    required: "Mandatory",


    chooseCategory: "Choose Category",
    chooseTypeStatus: "Choose Type Status",

    // Category Types
    food: "Food & Drink",
    house: "Housing",
    shopping: "Shopping",
    life: "Life & Enjoy",
    other: "Other",
    salary: "Salary",

    //Pages:
    showingOf: "SHOWING {{currentPage}} OF {{maxpage}}",

    // SWAL
      areYouSureTitle: "Are you sure?",
      warningText: "You won't be able to revert this!",
      confirmButtonText: "Yes, delete it!",
      deleted:"Deleted!",
      deletedMessage:"Your file has been deleted.",
      success: "success",
      emptyFieldsWarningMessage: "There are emptyfileds in the form!",
      successMessage: "Your message has been sent successfull!",
      failureMessage: "There was a problem sending your message!",
      emptySubjectOrMessageWarning: "Subject or message fields cannot be empty!",
      currencyTypeUpdated: 'Currency type updated!',
      currencyTypeUpdateFailled: 'Currency type cannot updated!',

    //Login page form
    emailOrPasswordNotEmpty: 'Email or password field cannot be empty!',
    emailNotFound: 'Email not found',
    differentSource: 'This e-mail address was used in the google login method. You can use the login option with Google.',
    passwordDoesntMatch: 'The entered password is incorrect',

    //create page
    confirmationPasswordDoesntMatch: 'Password does not match',
    passwordOfAtLeast: 'You must enter a password of at least 6 characters',
    registerErrorMessage: 'There was a problem registering',
    userRegisterSuccessful: 'User registration done successfully. You can login',
    userExist: 'The email address you used for registration has been used before',
  }
};
export default en;
